/****************************************************************************
 * COPYRIGHT (c) 2024 Harman Connected Services
 *
 * All rights reserved
 *
 * This software embodies materials and concepts which are
 * confidential to Ignite Product and is made available solely
 * pursuant to the terms of a written license agreement with
 * Ignite Product.
 *
 * Designed and Developed by Harman International Industries, Inc.
 ***************************************************************************/
import {
  FETCH_TEAM_DETAILS_REQUEST,
  FETCH_TEAM_DETAILS_SUCCESS,
  FETCH_TEAM_DETAILS_FAILURE,
} from "./TeamDetailsTypes";

const initialState = {
  loading: false,
  teams: {},
  error: "",
};

const teamDetailsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_TEAM_DETAILS_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case FETCH_TEAM_DETAILS_SUCCESS:
      return {
        loading: false,
        teams: action.payload,
        error: "",
      };
    case FETCH_TEAM_DETAILS_FAILURE:
      return {
        loading: false,
        teams: {},
        error: action.payload,
      };
    default:
      return state;
  }
};

export default teamDetailsReducer;
